<template>
    <div>
        <MainHeader />
        <div class="page">
            <div class="container">

                <h2>Frequently Asked Questions</h2>
                <p>
                    <strong>What types of files can I upload to define my area of interest?</strong><br/>
                    You can upload a georeferenced vector file in the following file formats: GeoPackage, FlatGeoBuf, Zipped Shapefile, GeoJSON, or KML. 
                    The file is converted to unprojected geographic coordinates in WGS84, and any features in the files are dissolved and merged to make a single feature 
                    that defines your area of interest. The maximum size for an area of interest is currently 10,000 square kilometers.
                </p>
                <p>
                    <strong>My factsheet is no longer accessible!</strong><br/>
                    We rolled out a large update in April 2022 which was not compatible with factsheets generated before that time. You can regenerate it from the homepage, 
                    and if you really want we can regenerate it for you if you send us the old URL. 
                </p>
                <p>
                    <strong>How long will a factsheet be available after I generate it?</strong><br/>
                    Factsheets will expire 21 days after creation, after that the data for the factsheet will be removed. To keep our hosting and infrastructure 
                    costs manageable we have to have remove data periodically and cannot preserve factsheets and data forever.  
                </p>
                <p>
                    Get in touch via <a href="mailto:info@geofolio.org">info@geofolio.org</a> if you have any other questions.
                </p>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
  import MainHeader from '@/components/generic/MainHeader.vue'
  import Footer from '@/components/generic/Footer.vue'

  export default {
    name: 'about',
    components: {
      MainHeader, Footer
    }
  }
</script>

<style scoped>

div.page {
    font-size:1.1em;
    color:#666;
}
h1 {
    font-size:1.3em;
    font-weight:600;
    margin-top:15px;
}

h2 {
    font-size:1.2em;
    font-weight:600;
    margin-top:15px;
}

h3 {
    font-size:1.05em;
    font-weight:600;
    margin-top:15px;
}
p {
    line-height:1.4em;
}
</style>